import { ProfileReportRequestDto } from '@diritto/common/account/dtos/profile-report.dtos';
import { BaseFileFiledDto } from '@diritto/common/base/base.dto';
import { NpsCampaignDto } from '@diritto/common/dataAnalysis/dtos/nps-campaign.dto';
import { NpsCampaignAnswerRequestDto } from '@diritto/common/dataAnalysis/dtos/nps-campaign.request.dto';

export enum ModalType {
  SelectDate = 'SelectDate',
  Alert = 'Alert',
  Confirm = 'Confirm',
  ContractProposal = 'ContractProposal',
  Toast = 'Toast',
  ContentCover = 'ContentCover',
  EditCover = 'EditCover',
  FancyShare = 'FancyShare',
  AppInstall = 'AppInstall',
  DirittoStudioWelcome = 'DirittoStudioWelcome',
  Intro = 'Intro',
  AppPushOn = 'AppPushOn',
  NpsCampaign = 'NpsCampaign',
  ReplyReport = 'ReplyReport',
  ProfileReport = 'ProfileReport',
  RittoCaught = 'RittoCaught',
  ContestVoteMessage = 'ContestVoteMessage',
  ContentCoverPolicyAlert = 'ContentCoverPolicyAlert',
  PromotionNotEligible = 'PromotionNotEligible',
  ConfirmFavoriteCategory = 'ConfirmFavoriteCategory',
  SelectFavoriteCategory = 'SelectFavoriteCategory',
}

export interface ModalParams {
  [ModalType.SelectDate]: {
    title?: string;
    description?: string;
    defaultValue?: Date;
    confirmText?: string;
    onConfirm?: (date: Date) => void;
    cancelText?: string;
    onCancel?: () => void;
  };
  [ModalType.Alert]: {
    title?: string;
    description?: string;
    confirmText?: string;
    onConfirm?: () => void;
    cancelText?: string;
    onCancel?: () => void;
  };
  [ModalType.Confirm]: {
    title?: string;
    description?: string;
    confirmText?: string;
    onConfirm?: () => void;
    cancelText?: string;
    onCancel?: () => void;
  };
  [ModalType.ContractProposal]: {
    contentId: number;
    authorProfileId: number;
    title: string;
    onConfirm?: () => void;
    onCancel?: () => void;
  };
  [ModalType.Toast]: {
    description?: string;
    isManualHide?: boolean;
    extraShowTimeSec?: number;
    externalLink?: { url: string; text: string };
    link?: { url?: string; onClick?: () => void; text: string };
    hideCallback?: () => void;
  };
  [ModalType.ContentCover]: {
    imageFile: BaseFileFiledDto;
  };
  [ModalType.EditCover]: undefined;
  [ModalType.AppInstall]: {
    title?: string;
    description?: string;
    onClickDownload?: () => void;
    cancelText?: string;
    onCancel?: () => void;
  };
  [ModalType.AppPushOn]: {
    title?: string;
    description?: string;
    onClickPushOn?: () => void;
    onCancel?: () => void;
  };
  [ModalType.NpsCampaign]: {
    npsCampaign: NpsCampaignDto;
    onSubmit?: (payload: NpsCampaignAnswerRequestDto) => void;
    onCancel?: () => void;
  };
  [ModalType.ReplyReport]: {
    replyId: number;
    ctxString: '댓글' | '답글';
    onSettled?: () => void;
    onCancel?: () => void;
  };
  [ModalType.ProfileReport]: {
    onSubmit?: (payload: ProfileReportRequestDto) => void;
    onCancel?: () => void;
  };
  [ModalType.FancyShare]: {
    profileId: number;
    contentTitle: string;
    author: string;
    episodeTitle: string;
    description: string;
    onSubmit?: (imageData: string, description?: string) => void;
  };
  [ModalType.DirittoStudioWelcome]: {
    onConfirm?: () => void;
    onCancel?: () => void;
  };
  [ModalType.ContentCoverPolicyAlert]: {
    onConfirm?: () => void;
    onCancel?: () => void;
  };
  [ModalType.Intro]: undefined;
  [ModalType.RittoCaught]: {
    dailyParticipateCountForPromotionId: number;
    onConfirm?: () => void;
    onCancel?: () => void;
  };
  [ModalType.ContestVoteMessage]: {
    voteId: number;
  };
  [ModalType.PromotionNotEligible]: {
    onConfirm?: () => void;
    onCancel?: () => void;
  };
  [ModalType.ConfirmFavoriteCategory]: {
    title: string;
    categoryIds: number[];
    onConfirm?: () => void;
    onCancel?: () => void;
  };
  [ModalType.SelectFavoriteCategory]: {
    onConfirm?: () => void;
    onCancel?: () => void;
  };
}
